import { DsIcon } from '@descomplica/design-system-react';
import { useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';

import {
  Classroom,
  ClassroomViewModel,
  Lesson,
} from '@/presentation/screens/classroom/classroom.vm';
import { LinkContainer } from '@/presentation/shared-components/anchor';

type ExerciseViewdTracking = {
  classroom: Classroom;
  lesson: Lesson;
};

type LessonExerciseProps = {
  url: string;
  label: string;
  openExercise: (isOpen: boolean, url: string, exercise?: LessonExercisesDto) => void;
  exercise?: LessonExercisesDto;
};

export type LessonExercisesDto = {
  lesson_guid: string;
  exercises_guid: string;
};

const LessonExercise: React.FC<ExerciseViewdTracking & LessonExerciseProps> = ({
  lesson,
  url,
  label,
  openExercise,
  exercise,
}) => {
  const vm = useViewModel(ClassroomViewModel);

  return (
    <LinkContainer
      onClick={() => {
        vm.handleExerciseViewed(lesson, url);
        openExercise(true, url, exercise);
      }}
      className="exercise-button"
      href="#"
      aria-label="Lista de exercício da aula"
      rel="noopener noreferrer"
    >
      <DsIcon image="edit" />
      <p>{label}</p>
    </LinkContainer>
  );
};

export default LessonExercise;
